import React, { useState, useEffect } from 'react'
import { Badge, Grid, CircularProgress, useMediaQuery, useTheme } from '@mui/material'
import serverData from '../../../../api/ServerData'
import { useNavigate } from 'react-router-dom'
import { logoutUser } from '../../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import NoRecordFound from '../../../../commonComponents/NoRecordFound'
import { TextBold } from '../../../../commonComponents/TextStyling'
import TabViewComponent from '../../../../commonComponents/TabViewComponent'
import JobItem from './JobItem'


export default function ManageJob ({ user }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
   var theme = useTheme()
  const [loading, setLoading] = useState(true)
  const [total, setTotal] = useState(0)
  const [jobPosts, setJobPosts] = useState({ active: [] })
const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(function () {
    getJobPosts()
  }, [])

  function getJobPosts () {
    serverData.getJobPosts(
      {},
      result => {
        if (result.status) {
          if (result.response) {
            var active = [],
              pending = [],
              draft = [],
              onhold = [],
              filled = [],
              closed = []

            for (var i = 0; i < result?.response.length; i++) {
              var item = result?.response[i]

              if (item?.status === 'active') {
                active?.push(item)
              } else if (item?.status === 'pending') {
                pending?.push(item)
              } else if (item?.status === 'draft') {
                draft?.push(item)
              } else if (item?.status === 'filled') {
                filled?.push(item)
              } else if (item?.status === 'onhold') {
                onhold?.push(item)
              } else if (item?.status === 'closed') {
                closed?.push(item)
              }
            }
            setJobPosts({ active, pending, draft, onhold, filled, closed })
            setTotal(result.response.length)
          }
          setLoading(false)
        }
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Grid container sx={{  width:isMobile? '100%' :"80%", margin: '0 auto' }}>
      <Grid item xs={12}>
        <TextBold style={{ fontSize: isMobile? '18px':'24px' }}>Manage Jobs</TextBold>
        <Badge
          badgeContent={total}
          color='primary'
          style={{ left: 14, top: -8 }}
        />
      </Grid>

      {loading ? (
        <Grid
          container
          spacing={2}
          direction={'column'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            width: '100%'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : (
        <TabViewComponent
          style={{
            padding: '24px 0px',
            whitespace: 'nowrap'
            // 550px
          }}
          tabs={[
            {
              id: 0,
              label: 'Active',
              badge: jobPosts.active.length,
              content: (
                <JobsDetails
                  data={jobPosts.active}
                  getJobPosts={getJobPosts}
                  jobStatusData={'active'}
                  user={user}
                />
              )
            },
            {
              id: 1,
              label: 'Pending',
              badge: jobPosts.pending.length,

              content: (
                <JobsDetails
                  data={jobPosts.pending}
                  getJobPosts={getJobPosts}
                  jobStatusData={'pending'}
                  user={user}
                />
              )
            },
            {
              id: 2,
              label: 'Draft',
              badge: jobPosts.draft.length,

              content: (
                <JobsDetails
                  data={jobPosts.draft}
                  getJobPosts={getJobPosts}
                  jobStatusData={'draft'}
                  user={user}
                />
              )
            },
            {
              id: 3,
              label: 'On-Hold',
              badge: jobPosts.onhold.length,

              content: (
                <JobsDetails
                  data={jobPosts.onhold}
                  getJobPosts={getJobPosts}
                  jobStatusData={'onhold'}
                  user={user}
                />
              )
            },
            {
              id: 4,
              label: 'Filled',
              badge: jobPosts.filled.length,

              content: (
                <JobsDetails
                  data={jobPosts.filled}
                  getJobPosts={getJobPosts}
                  jobStatusData={'filled'}
                  user={user}
                />
              )
            },
            {
              id: 5,
              label: 'Closed',
              badge: jobPosts.closed.length,

              content: (
                <JobsDetails
                  data={jobPosts.closed}
                  getJobPosts={getJobPosts}
                  jobStatusData={'closed'}
                  user={user}
                />
              )
            }
          ]}
        />
      )}
    </Grid>
  )
}

function JobsDetails ({ data, jobStatusData, getJobPosts, user }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [subEmployers, setSubEmployers] = useState([])

  useEffect(function () {
    if (!user.isSubEmployer) {
      getSubEmployers()
    }
  }, [])

  function getSubEmployers () {
    serverData.getSubEmployers(
      {},
      result => {
        if (result.status) {
          setSubEmployers(result.response)
        }
      },
      error => {
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return data?.length > 0 ? (
    <>
      {data?.map((item, index) => (
        <JobItem
          item={item}
          jobStatusData={jobStatusData}
          getJobPosts={getJobPosts}
          subEmployers={subEmployers}
          isSubEmployer={user.isSubEmployer}
        />
      ))}
    </>
  ) : (
    <div
      style={{
        padding: '20px',
        width: '100%'
      }}
    >
      <NoRecordFound />
    </div>
  )
}
